export default {
  data() {
    return {
      
    }
  },
  methods: {
    accueil: function() {
      this.$root.initSouscription();
      this.$router.push({path: this.$root.menu.homePage});
      
    }
  }

}